var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6426 56.0152V55.2519H55.0734V47.8174H55.8362V56.0152H47.6426Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000455856 47.8193L0.763677 47.8193L0.763677 55.2501L8.19824 55.2501L8.19824 56.013L0.000455498 56.013L0.000455856 47.8193Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8362 8.19768H55.0734V0.763113H47.6426V0H55.8362V8.19768Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21306 0V0.763003H0.78226V8.19757H0.0195312V0H8.21306Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6123 44.6977V40.2164L23.6066 40.2218H25.8344V37.9781H23.6066L23.6123 37.983C23.61 37.2356 23.608 36.488 23.6062 35.7401H28.0944V33.5139H30.3274V35.7302H32.5658V31.2634L32.5601 31.2687C32.655 31.2687 32.7498 31.2656 32.8443 31.2656L39.2794 31.2622V33.4911H41.5019V31.2679H39.2745V29.0178H34.794V24.5631H28.0788V26.7954H23.6218V31.2755H25.8374V33.5097H23.6115V35.7481H21.3754V33.5048H14.6641V31.2729H21.3644V13.3618H23.6115L23.6062 13.3564C23.6062 15.5113 23.6072 17.6664 23.6093 19.8215V20.0602H25.8454V15.607H28.0777V20.0769H30.3267L30.3214 20.0715V22.3076H41.5091V24.5411H43.7517V26.7912L43.7574 26.7863H41.5296V29.0299H43.7574L43.7517 29.0246V33.507H45.9954L45.99 33.5017V37.9724H43.7672V42.4605H45.9954L45.99 42.4552V44.6936H50.4596V46.9274H43.7593V51.4041H41.5247V49.1729H37.0373L37.0426 49.1783V46.9399H34.8095V44.7057H39.2654V42.4673H28.0944V44.6924H23.607L23.6123 44.6977ZM37.0373 37.9826V35.7549H34.8152V37.9785H37.043V40.2062H41.5023V37.9838L37.0373 37.9826ZM32.5544 37.9933H30.3396V40.2073H32.5544V37.9933ZM37.0479 26.7753H39.2628V24.5604H37.0479V26.7753Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47266 20.0601V4.41504H19.1178V20.0601H3.47266ZM5.71597 6.6534V17.8202H16.8847V6.6534H5.71597Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4583 20.0659H34.8135V4.4209H50.4583V20.0659ZM48.2252 6.65775H37.0568V17.8253H48.2252V6.65775Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47656 35.752H19.1221V51.397H3.47656V35.752ZM16.8849 37.9953H5.71684V49.1636H16.8849V37.9953Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6113 13.362V8.88527H21.3809V4.41992H32.5504V8.87616H30.3386V11.1176H32.553V15.5833H30.326V13.3628H28.0915V11.1305H25.8557V13.3559H23.606L23.6113 13.362ZM25.8557 8.86858H28.0702V6.65373H25.8557V8.86858Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.6526 24.5488V26.7872H19.1225V29.0214H12.4214V33.4981H3.47852V29.0404H5.69527V31.251H10.1823V24.5488L10.1766 24.5541H14.6579L14.6526 24.5488Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6065 44.6924V46.9307H25.8407V49.1649H28.0734V51.4033H21.3848V44.6977H23.6118L23.6065 44.6924Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.1835 24.5486H5.70899V26.7782H3.48047V22.3262H10.1778V24.5539L10.1835 24.5486Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.4566 29.0184H48.2364V24.5576H46.0049V22.3223H50.4566V29.0184Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.6586 24.5533V22.3252H19.1206V24.548H14.6533L14.6586 24.5533Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.9975 33.507V31.2793H48.2211V33.5017H45.9922L45.9975 33.507Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.2412 35.752H50.4557V37.9702H48.2412V35.752Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.3276 20.0764V17.8486H32.5512V20.0711H30.3223L30.3276 20.0764Z",
    fill: "#2965FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.6129 40.2169H21.3848V37.9834H23.6129L23.6072 37.9785V40.2222L23.6129 40.2169Z",
    fill: "#2965FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.9975 42.4602V40.2324H48.2211V42.4549H45.9922L45.9975 42.4602Z",
    fill: "#2965FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.752 26.7911H45.9801V29.0245H43.752L43.7576 29.0298V26.7861L43.752 26.7911Z",
    fill: "#2965FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.5507 49.1641H30.334V46.9492H32.5492L32.5507 49.1641Z",
    fill: "#2965FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.039 49.1689V51.3967H34.8154V49.1743H37.0443L37.039 49.1689Z",
    fill: "#2965FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.4557 51.4023H48.2412V49.1875H50.4557V51.4023Z",
    fill: "#2965FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.567 31.2636H30.3389V29.04H32.5613V31.2689L32.567 31.2636Z",
    fill: "#2965FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6408 15.5881H7.94727V8.89648H14.6408V15.5881Z",
    fill: "#2965FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2871 15.5832V8.8916H45.9787V15.5832H39.2871Z",
    fill: "#2965FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94727 46.9205V40.2285H14.6389V46.9205H7.94727Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.509fe8deaf69b3a68654291cf03b320b.svg";
export { ForwardRef as ReactComponent };